<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <NuxtImg
      v-for="image in eventImages"
      :key="image?.id"
      class="w-full"
      :height="'auto'"
      :preload="true"
      :src="String(image?.cropped)"
      :alt="image?.alt"
      aspect-ratio="auto"
      loading="lazy"
      sizes="xs:100vw sm:100vw md:100vw lg:910px xl:910px xxl:910px"
      @click="$emit('click:image')"
    />
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  event: EventDescription
}>()

const eventImages = computed(() => eventGetters.getGalleryImages(props.event))
</script>
